// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_round_ribbed_shell/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_round_ribbed_shell: ModuleSchema = {
  "id": "core_round_ribbed_shell",
  "uniqueId": "B3D_RIB03",
  "createdAt": "2026-10-10T15:38:06.949Z",
  "updatedAt": "2026-10-10T15:43:25.355Z",
  "label": "Round Ribbed Shell",
  "description": "Khối trụ mẫu với các gân bán tròn lồi chạy dọc quanh vỏ.",
  "category": "core_geometry",
  "tags": [
    "core",
    "geometry",
    "shell",
    "rib",
    "rounded",
    "raised"
  ],
  "sliders": [
    {
      "key": "radius",
      "label": "Shell Radius",
      "min": 8,
      "max": 80,
      "step": 1,
      "default": 28,
      "unit": "mm"
    },
    {
      "key": "height",
      "label": "Shell Height",
      "min": 8,
      "max": 80,
      "step": 1,
      "default": 24,
      "unit": "mm"
    },
    {
      "key": "ribCount",
      "label": "Number of Rounded Ribs",
      "min": 0,
      "max": 48,
      "step": 1,
      "default": 24
    },
    {
      "key": "ribEndMargin",
      "label": "Rib End Margin",
      "min": 0,
      "max": 12,
      "step": 0.5,
      "default": 1.5,
      "unit": "mm"
    },
    {
      "key": "ribWidth",
      "label": "Rounded Rib Width",
      "min": 0.4,
      "max": 12,
      "step": 0.1,
      "default": 2.4,
      "unit": "mm"
    },
    {
      "key": "ribHeight",
      "label": "Rounded Rib Height",
      "min": 0.1,
      "max": 8,
      "step": 0.1,
      "default": 1.2,
      "unit": "mm"
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "shell",
      "label": "Round Ribbed Shell",
      "default": "#ffffff",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "name": "Round Ribbed Shell",
      "parts": [
        {
          "name": "Round Ribbed Shell",
          "groupId": 0
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "name": "Round Ribbed Shell",
      "groupId": 0
    }
  ]
};
